export type ProfileTier = 'T0' | 'T1' | 'T2';

export const PROFILE_TIERS: Record<ProfileTier, ProfileTier> = {
    T0: 'T0',
    T1: 'T1',
    T2: 'T2',
};
